import React, { useCallback, useState } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import ModalContent from 'components/basic/modal/components/ModalContent';
import ModalFooterButtons from 'components/basic/modal/components/ModalFooterButtons';
import SimpleModalOrMobilePage from 'components/basic/modal/SimpleModalOrMobilePage';
import { staticDispatch, useSelector } from 'reduxState/store';
import {
  showWalletModal,
  updatePendingWalletAddress,
} from 'reduxState/wallet/walletDetailsReducer';

import RememberMe from '../unlock/RememberMe';

const GrayText = styled.div`
  color: var(--gray4c);
  padding-top: 8px;
  line-height: 1.5;
`;

// TODO: https://docs.google.com/document/d/1mO-QLY0H9iFfTsP-4V4hY1Isc_P7XhmhDbfY_fQJzJM/edit
function WalletModalAddressIncorrect() {
  const { pathname } = useLocation();
  const walletAddress = useSelector(state => state.wallet.walletAddress);
  const walletType = useSelector(state => state.wallet.walletType);
  const walletRdns = useSelector(state => state.wallet.walletDiscoveryRdns);
  const unlockModalOpen = useSelector(
    state => state.walletDetail.unlockModalOpen
  );
  const pendingWalletAddress = useSelector(
    state => state.walletDetail.pendingWalletAddress
  );

  const [remember, setRemember] = useState(true);

  const handleClose = useCallback(() => {
    staticDispatch(updatePendingWalletAddress(undefined));
  }, []);

  if (unlockModalOpen || pathname.startsWith('/unlock')) {
    // Hide popup on Unlock page
    return null;
  }

  if (!walletAddress) {
    return null;
  }

  if (pendingWalletAddress && pendingWalletAddress !== walletAddress) {
    return (
      <SimpleModalOrMobilePage
        onClose={handleClose}
        title="Wallet Change Detected"
        zIndex={123456}
        size="small"
        padding="0"
        verticalAlignOnMobile="ceneteredDiv"
      >
        <ModalContent>
          <GrayText>Unlock your new wallet to continue.</GrayText>
        </ModalContent>
        <ModalFooterButtons
          confirmButtonProps={{
            inline: true,
            widePadding: true,
            children: 'Connect',
            onClick: () => {
              handleClose();
              if (!walletType) {
                return;
              }
              staticDispatch(
                showWalletModal({
                  preSelect: { walletType, rdns: walletRdns, remember },
                })
              );
            },
          }}
        >
          <RememberMe
            remember={remember}
            onChange={setRemember}
            disabled={false}
          />
        </ModalFooterButtons>
      </SimpleModalOrMobilePage>
    );
  }
  return null;
}

export default WalletModalAddressIncorrect;
